<template>
    <div>
        <div class="message-details-container" v-loading="loading" element-loading-text="Loading...">
            <el-card shadow="never" v-if="messageInfo && status === 1">
                <div class="card-header" slot="header">
                    <span class="title">
                        <i class="msg-icon" :class="[messageInfo.Type]"></i>
                        From: <strong>{{ messageInfo.SEName }}</strong>
                    </span>
                    <span class="datetime">{{ messageInfo.CreatedOn }}</span>
                </div>
                <div class="card-body" :class="[messageInfo.Type]">
                    <template v-if="messageInfo.Type === 'image'">
                        <el-image :src="messageInfo.Url" :preview-src-list="[messageInfo.Url]" fit="contain"
                            :z-index="9999">
                            <div slot="placeholder">
                                Loading
                                <span class="dot">...</span>
                            </div>
                            <div slot="error" class="error-image-slot"></div>
                        </el-image>
                    </template>
                    <template v-else-if="messageInfo.Type === 'video'">
                        <video :src="messageInfo.Url" :poster="messageInfo.Poster" controlslist="nodownload" controls />
                    </template>
                    <template v-else-if="messageInfo.Type === 'voice'">
                        <VoicePlayer :src="messageInfo.Url" />
                    </template>
                    <template v-else-if="messageInfo.Type === 'text'">{{ messageInfo.Message }}</template>
                    <template v-else-if="messageInfo.Type === 'link'">
                        <el-link class="link" type="primary" @click="goTo(messageInfo)">
                            {{ messageInfo.Message }}
                        </el-link>
                    </template>
                </div>
            </el-card>
            <div class="tips-wrapper" v-else-if="!messageInfo && status === 0">
                <el-result icon="info" subTitle="The message does not exist or has been deleted."></el-result>
            </div>
            <div class="tips-wrapper" v-else-if="!loading && status === -2">
                <el-result icon="error" subTitle="Loading failed, please check the network and try again"></el-result>
            </div>
        </div>
    </div>
</template>
<script>
import VoicePlayer from '../../components/voice-player'
import moment from 'moment'
import * as _ from 'lodash'
export default {
    name: "Message-Details",
    components: { VoicePlayer },
    data() {
        return {
            loading: false,
            messageInfo: null,
            status: -1
        }
    },
    computed: {
        path() {
            return this.$route.path;
        },
        msgId() {
            return this.$route.params.msgId
        }
    },
    created() {
        this.bus.$on("refresh", ({ name }) => {
            if (this.$options.name === name) {
                this.getMessageInfo();
            }
        });
        this.getMessageInfo();
    },
    methods: {
        getMessageInfo() {
            if (!this.msgId) return
            this.loading = true
            this.status = -1
            this.axios.get(`/message/${this.msgId}`).then(({ code, data }) => {
                if (200 === code && data) {
                    this.messageInfo = data
                    this.status = 1
                    this.bus.$emit("setTabTitle", {
                        path: this.path,
                        title: moment(data.CreatedOn).format('YYYYMMDDHHmmss') + '_' + _.upperFirst(data.Type),
                    });
                } else {
                    this.status = 0
                }
                this.loading = false;
            }).catch(() => {
                this.loading = false;
                this.status = -2
            });
        },
        goTo(data) {
            this.$confirm(`您即将离开礼来远程学术在线，前往第三方网站(${data.Url})。该网站风险未知，请您谨慎甄别。`, {
                title: '第三方网站跳转提醒',
                customClass: 'go-to-confirm-dialog',
                confirmButtonText: '跳转 ',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                window.open(data.Url, '_blank')
            }).catch(() => { })
        }
    }
}
</script>

<style lang="scss" scoped>
.message-details-container {
    min-width: 800px;
    border-radius: 10px;
    background-color: #fff;
    padding: 15px;
    height: calc(100vh - 65px);

    .el-card {
        height: 100%;
        border: none;
        display: flex;
        flex-direction: column;

        &::v-deep {

            .el-card__header,
            .el-card__body {
                padding: 10px;
            }

            .el-card__body {
                height: 100%;
            }
        }

        strong {
            margin-left: 5px;
        }
    }

    .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .msg-icon {
            display: block;
            height: 20px;
            width: 20px;
            margin-right: 5px;
            background-size: contain;
            background-repeat: no-repeat;

            &.link {
                background-image: url(../../assets/img/icon-link-two.svg);
            }

            &.text {
                background-image: url(../../assets/img/icon-text.svg);
            }

            &.image {
                background-image: url(../../assets/img/icon-picture-one.svg);
            }

            &.video {
                background-image: url(../../assets/img/icon-video-one.svg);
            }

            &.voice {
                background-image: url(../../assets/img/icon-voice-one.svg);
            }
        }

        .title {
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .datetime {
            color: #909399;
        }
    }

    .card-body {
        height: 100%;

        &.text,
        &.link {
            display: block;
        }
    }

    .card-body,
    .tips-wrapper,
    .el-image {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .error-image-slot {
        display: block;
        height: 40px;
        width: 40px;
        background-image: url(../../assets/img/icon-error-picture.svg);
        background-size: cover;
    }

    .tips-wrapper {
        height: 100%
    }

    .el-image {
        width: 800px;
        height: 500px;
    }

    video {
        width: 800px;
        height: calc(800px * 9 / 16);
        background-color: #000;
    }

    video,
    audio {
        margin: 0 auto;
    }

    link {
        line-height: 16px;
    }

}
</style>
